import {db} from '@/firebase'
import EventEmitter from 'events'
import { store } from '@/store'

import moment from 'moment'

// Extend EventEmitter so user of EmergencyRepository can react to our own defined events. (ex: emergencyRepository.on('added'))
class RecommendationRepository extends EventEmitter {
    constructor () {
        super()

        this.collection = db.collection('recommendations')

        return this
    }

    all (onSuccess, onError) {
        db.collection('recommendations')
            .get()
            .then((querySnapshot) => {
                let recommendations = []

                querySnapshot.forEach((doc) => {
                    let recommendation = doc.data()

                    recommendations.push(recommendation)
                });

                onSuccess(recommendations)
            })
            .catch((error) => {
                onError(error)
            })
    }

    createMany (doctor, recommendations, onSuccess, onError) {
        var batch = db.batch()
        var recommendationDocs = {}

        recommendations.forEach((item, index, array) => {
            var recommendationRef = db.collection('recommendations').doc()

            recommendationDocs[recommendationRef.id] = {
                id: recommendationRef.id,
                fromFirstName: doctor.firstName,
                fromLanguage: doctor.language,
                fromLastName: doctor.lastName,
                fromId: doctor.id,
                toEmail: item.email,
                toName: item.name,
                toId: null
            }

            batch.set(recommendationRef, recommendationDocs[recommendationRef.id])
        })

        batch.commit()
            .then(() => {
                store.dispatch('setRecommendations', recommendationDocs)
                store.dispatch('setLoaded', true)
                store.dispatch('setLoading', false)
                onSuccess()
            })
            .catch((error) => {
                console.log('commit error')
                console.error(error)
                onError(error)
            })
    }
}

export default new RecommendationRepository()



// WEBPACK FOOTER //
// ./src/data/RecommendationRepository.js